@if ((config | async).bot.active || (config | async).live.active) {
    @switch (viewMode) {
        @case (0) {
            <button
                (click)="toggleVisibility()"
                class="fixed px-6 py-4 bg-white rounded-md shadow-lg hover:shadow-lg-active z-(--z-chat-button) right-4 bottom-4 sm:mx-0 leading-0">
                <big-icon
                    [icon]="iconChat"
                    [size]="'w-6'"
                    class="icon fill-primary" />
                <span class="sr-only">
                    {{ !(config | async).panel.visible ? (config | async).toggle.choose.open : (config | async).toggle.choose.close }}
                </span>
            </button>
        }
        @case (1) {
            <big-ui-button
                [buttonStyle]="'primary'"
                (clicked)="setViewMode(1)">
                @if ((config | async).panel.visible && (config | async).panel.viewMode !== viewModeEnum.chatBot) {
                    {{ (config | async).toggle.bot.switch }}
                }
                @if ((config | async).panel.visible && (config | async).panel.viewMode === viewModeEnum.chatBot) {
                    {{ (config | async).toggle.bot.close }}
                }
                @if (!(config | async).panel.visible) {
                    {{ (config | async).toggle.bot.open }}
                }
            </big-ui-button>
        }
        @case (2) {
            <big-ui-button
                [buttonStyle]="'primary'"
                (clicked)="setViewMode(2)">
                @if ((config | async).panel.visible && (config | async).panel.viewMode !== viewModeEnum.liveChat) {
                    {{ (config | async).toggle.live.switch }}
                }
                @if ((config | async).panel.visible && (config | async).panel.viewMode === viewModeEnum.liveChat) {
                    {{ (config | async).toggle.live.close }}
                }
                @if (!(config | async).panel.visible) {
                    {{ (config | async).toggle.live.open }}
                }
            </big-ui-button>
        }
    }
}
